import { TableCell, TableContainer, alpha, styled } from '@mui/material';
import Modal from 'components/Modal';

export const StyledRubricModal = styled(Modal)(({ theme }) => ({
	'& .MuiDialog-paper': {
		maxWidth: 'min(1440px, calc(100% - 32px))',
	},

	[theme.breakpoints.down('sm')]: {
		'& .MuiDialog-paper': {
			maxWidth: 'calc(100% - 16px)',
			margin: '8px',
		},
	},
}));

export const StyledRubricTableContainer = styled(TableContainer)(({ theme }) => ({
	border: `1px solid ${alpha(theme.palette.text.primary, 0.35)}`,
	borderRadius: '8px',
	overflowX: 'auto',

	'& .MuiTableCell-root': {
		border: `1px solid ${alpha(theme.palette.text.primary, 0.35)}`,
		padding: '16px',
		verticalAlign: 'top',
	},

	'& .MuiTableCell-head': {
		backgroundColor: alpha(theme.palette.primary.main, 0.06),
		color: theme.palette.error.contrastText,
		fontWeight: 600,
		textAlign: 'center',
		verticalAlign: 'middle',
	},

	[theme.breakpoints.down('sm')]: {
		'& .MuiTableCell-root': {
			padding: '12px',
		},
	},
}));

export const StyledRubricLevelCell = styled(TableCell, {
	shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
	minWidth: '220px',
	...(isSelected && {
		backgroundColor: alpha(theme.palette.primary.main, 0.14),
		boxShadow: `inset 0 0 0 2px ${theme.palette.primary.main}`,
	}),
}));

export const StyledCriteriaCell = styled(TableCell)({
	minWidth: '260px',
});

export const StyledCriteriaTitle = styled('div')(({ theme }) => ({
	color: theme.palette.error.contrastText,
}));

export const StyledMarkCell = styled(TableCell)({
	minWidth: '96px',
	textAlign: 'center',
	verticalAlign: 'middle !important',
});
